export default __webpack_public_path__ + "static/media/ai-image-generator-mobile-3.b8a574dd.png";